<div class="k-form">
    <label class="k-form-field">
        <span>From</span>
        <kendo-datepicker (valueChange)="onStartChange($event)"
            [(ngModel)]="start" [max]="max" [popupSettings]="popupSettings">
        </kendo-datepicker>
    </label>
    <label class="k-form-field">
        <span>To</span>
        <kendo-datepicker (valueChange)="onEndChange($event)"
            [(ngModel)]="end" [min]="min" [popupSettings]="popupSettings">
        </kendo-datepicker>
    </label>
</div>